import React from 'react';
import PropTypes from 'prop-types';
import OProductDetailInfo from './_organisme.product-detail-info';
import MProductGallery from '../../molecules/_molecules.product-gallery';
import MProductDetailControls from '../../molecules/_molecules.product-detail-controls';

export default function OProductDetail({
	title,
	featuredImage,
	description,
	showVideo,
	items,
	images,
	atex,
	price,
	webshop,
	isCompared,
	documents,
	onCompare,
	onContact,
	onVideoClick,
}) {
	return (
		<section className="o-product-detail">
			<MProductGallery
				featuredImage={featuredImage}
				items={images}
				showVideo={showVideo}
				onVideoClick={onVideoClick}
				className="product-gallery"
				onClick={onVideoClick}
			/>
			<OProductDetailInfo
				title={title}
				price={price}
				description={description}
				items={items}
				atex={atex}
			/>
			<MProductDetailControls
				title={title}
				webshop={webshop}
				documents={documents}
				showCompare={items.length > 0}
				onCompare={onCompare}
				isCompared={isCompared}
				onContact={onContact}
				className="product-detail--controls"
			/>
		</section>
	);
}

OProductDetail.propTypes = {
	title: PropTypes.string.isRequired,
	featuredImage: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	items: PropTypes.array,
	onCompare: PropTypes.func.isRequired,
	onContact: PropTypes.func.isRequired,
	isCompared: PropTypes.bool,
	documents: PropTypes.array,
	atex: PropTypes.array,
	showVideo: PropTypes.bool,
	images: PropTypes.array,
	price: PropTypes.string,
	webshop: PropTypes.string,
	onVideoClick: PropTypes.func,
};

OProductDetail.defaultProps = {
	documents: [],
	atex: [],
	items: [],
	images: [],
	showVideo: false,
	price: undefined,
	webshop: undefined,
	isCompared: false,
	onVideoClick: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/product/_organisme.product-detail.js